// DillySocks "Bundle & Sparen" Widget – Eigenes Bundle (Mix-Bundle).
// Lädt bis zu 4 verwandte Produkte (Shopify Recommendations API), lässt pro
// Zeile Produkt UND Grösse wählen und fügt alle zusammen dem Warenkorb hinzu.
//
// Der Rabatt wird an der Kasse durch die eigene Shopify-App "ds-bundle-discount"
// real abgezogen (Discount Function, gruppiert per Zeilen-Eigenschaft _ds_bundle).

import { CartLinesUpdateEvent } from '@shopify/events';

(() => {
  // Rabattsätze kommen aus dem Markup (data-discount-tiers, "5,10,15"),
  // damit sie ohne Code-Änderung an die echten Shopify-Rabatte angeglichen
  // werden können. EINE Kurve fuer alle drei Tabs, nach Gesamtmenge
  // (Sean 26.08.): 2-3 Stueck = 5 %, 4-5 = 10 %, ab 6 = 15 %.
  const cfgEl = document.querySelector('[data-ds-bundle]');

  // Übersetzte Strings kommen aus dem JSON-Block, den ds-pdp-bundle.liquid
  // rendert (dieses Asset ist ein statisches <script src>, kein {% javascript %}-
  // Tag — Liquid kann hier nicht direkt interpolieren). [[token]]-Platzhalter
  // in den Werten werden unten per fmt() manuell ersetzt.
  const I18N_EL = document.querySelector('[data-ds-bundle-i18n]');
  const I18N = I18N_EL ? JSON.parse(I18N_EL.textContent) : {};
  function fmt(str, vars) {
    return (str || '').replace(/\[\[(\w+)\]\]/g, (_, key) => (vars && key in vars ? vars[key] : ''));
  }

  const TIERS = (function () {
    const raw = cfgEl && cfgEl.dataset.discountTiers ? cfgEl.dataset.discountTiers.split(',') : [];
    const nums = raw.map((v) => parseFloat(v)).filter((v) => Number.isFinite(v));
    return nums.length === 3 ? nums.map((v) => v / 100) : [0.05, 0.1, 0.15];
  })();
  // Rabattsatz fuer ein Bundle mit n Stueck gesamt (unter 2: kein Rabatt).
  function bundleRate(n) {
    if (n >= 6) return TIERS[2];
    if (n >= 4) return TIERS[1];
    if (n >= 2) return TIERS[0];
    return 0;
  }
  const MIX_MIN_ITEMS = 2;

  // Rabatt läuft NICHT mehr über Rabattcodes (die galten immer für den ganzen
  // Warenkorb), sondern über unsere Shopify-App "ds-bundle-discount": Jede
  // Bundle-Zeile bekommt die versteckte Eigenschaft `_ds_bundle` (Unterstrich-
  // Präfix = im Checkout unsichtbar). Die Discount Function der App gruppiert
  // die Zeilen nach diesem Wert und rabattiert NUR sie — Zielkurve fuer alle
  // Modi: 2-3 Stueck = 5 %, 4-5 = 10 %, ab 6 = 15 % (die Function muss von
  // Sean auf diese Kurve deployt werden, siehe ds-pdp-bundle.liquid).
  // Jeder Klick auf "hinzufuegen" erzeugt eine eigene Gruppe.
  function makeBundleTag(mode) {
    return mode + '-' + Date.now().toString(36) + Math.random().toString(36).slice(2, 6);
  }
  const INITIAL_ITEMS = 4; // Startbestueckung aus den Empfehlungen
  const MIN_AVAILABLE_VARIANTS = 2; // "in beiden Grössen verfügbar"
  const CANDIDATE_POOL_LIMIT = 12; // Pool für das Produkt-Wechsel-Dropdown

  // "Gleiches Design": Mengen-Rabattstufen für dasselbe Produkt — nutzt aus
  // der Kurve nur die Stufen-Mengen 2 / 4 / 6 (keine Zwischenmengen).
  const SAME_DESIGN_TIERS = [
    { qty: 1, discount: 0, label: I18N.sameDesign.tierSingle },
    { qty: 2, discount: bundleRate(2), label: I18N.sameDesign.tierTwo },
    { qty: 4, discount: bundleRate(4), label: I18N.sameDesign.tierFour },
    { qty: 6, discount: bundleRate(6), label: I18N.sameDesign.tierSix, bestDeal: true },
  ];

  // "Partnerlook": Kids-Kollektion für den Erwachsenen->Kids-Match, "Alle
  // Styles" (die allgemeine Erwachsenen-Kollektion) für den umgekehrten
  // Weg (Kids->Erwachsene). KEIN Bestseller-Fallback mehr - gibt es zum
  // aktuellen Design kein passendes Gegenstück, wird kein zufälliges
  // Ersatzprodukt vorgeschlagen (ergab z.B. "Lil Easter Gang" für
  // komplett unpassende Designs), sondern ein Link zur jeweiligen
  // Kollektion angezeigt.
  const KIDS_COLLECTION_HANDLE = 'kindersocken';
  const ADULT_COLLECTION_HANDLE = 'alle-socken-designs';

  /* Waehrung/Format des aktiven Markts (snippets/ds-market.liquid).
     ROOT = Markt-Pfadpraefix fuer die AJAX-Endpoints — ohne ihn liefern
     /products/x.js, /collections/x/products.json und /recommendations/...
     immer CHF-Preise, auch im DE-/EU-Markt. */
  const MARKET = window.DS_MARKET || {};
  const ROOT = MARKET.root || '';
  // Gratisversand-Schwelle des Markts (Rappen/Cent, CH: 60.-): "Inklusive
  // Gratis-Versand" erscheint nur, wenn der rabattierte Bundle-Preis die
  // Schwelle erreicht (Sean 28.08. — stand vorher statisch unter jedem Bundle).
  const FREE_SHIP_CENTS = Number(MARKET.freeShippingCents) || 0;
  function toggleShipping(el, discountedCents) {
    if (el) el.hidden = !(FREE_SHIP_CENTS > 0 && discountedCents >= FREE_SHIP_CENTS);
  }
  function formatMoney(cents) {
    if (typeof window.dsMoney === 'function') return window.dsMoney(cents);
    return (cents / 100).toFixed(2) + ' ' + (MARKET.currency || '');
  }

  // Paare pro Stueck. Autoritativ ist das Metafeld custom.number_of_socks
  // (als data-pairs-per-unit am Bundle-Root, gilt fuer das SEITEN-Produkt;
  // fuer Fremdprodukte aus den AJAX-Endpoints ist es nicht verfuegbar).
  // Fallback-Reihenfolge fuer Fremdprodukte: 1) Produkt-TITEL ("(7er Pack)",
  // "(3er Box)") — verlaesslich, weil DillySocks-Namen den Pack-Zusatz tragen;
  // 2) Tags, dort das MAXIMUM aller Treffer (Alt-Tags wie "4er Pack" neben
  // "7er Pack" lieferten sonst die falsche erste Zahl — Sean 27.08.).
  const MAIN_PAIRS = parseInt((cfgEl && cfgEl.dataset.pairsPerUnit) || '', 10) || 0;
  const MAIN_PRODUCT_ID = cfgEl ? String(cfgEl.dataset.productId || '') : '';
  function pairsFromText(text) {
    let max = 0;
    const re = /(\d+)\s*er[\s-]*(pack|box)/gi;
    let m;
    while ((m = re.exec(text))) max = Math.max(max, parseInt(m[1], 10));
    return max;
  }
  function pairsPerUnit(product) {
    if (MAIN_PAIRS > 0 && product && String(product.id) === MAIN_PRODUCT_ID) return MAIN_PAIRS;
    const fromTitle = pairsFromText((product && product.title) || '');
    if (fromTitle) return fromTitle;
    return pairsFromText(((product && product.tags) || []).join('|')) || 1;
  }

  // Summe der Paare ueber mehrere Bundle-Zeilen (Partnerlook/Eigenes Bundle):
  // jede Zeile = 1 Stueck, mal Paare-pro-Stueck des jeweiligen Produkts.
  function sumPairs(items) {
    return items.reduce((n, it) => n + (it.product ? pairsPerUnit(it.product) : 1), 0);
  }

  // "pro Paar XX.XX CHF" fuer ein data-Attribut-Element setzen (leer bei 0).
  function setPerPair(el, discountedCents, pairs) {
    if (!el) return;
    el.textContent = pairs > 0 ? fmt(I18N.perPair, { n: formatMoney(Math.round(discountedCents / pairs)) }) : '';
  }

  function initTabs(root) {
    const buttons = root.querySelectorAll('[data-tab-btn]');
    const panels = root.querySelectorAll('.ds-bundle__panel');
    buttons.forEach((btn) => {
      btn.addEventListener('click', (ev) => {
        // Echte Nutzer-Klicks merken: danach schaltet initPartnerlook den
        // Tab nicht mehr automatisch auf "Partnerlook" um.
        if (ev && ev.isTrusted) root.dataset.dsTabTouched = '1';
        buttons.forEach((b) => {
          b.classList.remove('ds-bundle__tab--active');
          b.setAttribute('aria-selected', 'false');
        });
        btn.classList.add('ds-bundle__tab--active');
        btn.setAttribute('aria-selected', 'true');
        const tab = btn.dataset.tabBtn;
        panels.forEach((p) => {
          p.hidden = p.dataset.tab !== tab;
        });
      });
    });
  }

  function buildSizeOptions(select, product) {
    select.innerHTML = '';
    product.variants
      .filter((v) => v.available)
      .forEach((v) => {
        const opt = document.createElement('option');
        opt.value = v.id;
        opt.dataset.price = v.price;
        opt.dataset.compareAtPrice = v.compare_at_price || '';
        opt.textContent = v.public_title || v.title;
        select.appendChild(opt);
      });
  }

  /* Zeilenpreis (Eigenes Bundle / Partnerlook), Sean 18.08.2026:
     rot = Preis abzueglich Bundle-Rabatt (so wie Shopify rechnet: pro
     Artikel abgerundet), darunter durchgestrichen der Preis OHNE Bundle-
     Rabatt. Ist das Produkt bereits reduziert (compare_at > price), ist der
     Streichpreis der bereits reduzierte Preis — nicht der UVP. */
  function updateItemPrice(item, rate) {
    const opt = item.sizeSelect.selectedOptions[0];
    if (!opt) return;
    const price = parseInt(opt.dataset.price, 10);
    const r = typeof rate === 'number' ? rate : item.rate || 0;
    const discounted = price - Math.floor(price * r);
    item.priceEl.innerHTML = formatMoney(discounted) + (r > 0 ? ' <s>' + formatMoney(price) + '</s>' : '');
  }

  // Eigenes Dropdown statt <select> für den Produkt-Wechsel: native
  // <option>-Elemente können in keinem gängigen Browser ein Bild anzeigen,
  // Bilder sind hier aber nötig, um Produkte auseinanderzuhalten.
  function closeAllMenus(items, except) {
    items.forEach((item) => {
      if (item === except) return;
      item.productMenu.hidden = true;
      item.productTrigger.setAttribute('aria-expanded', 'false');
    });
  }

  // Jede Zeile darf nur Produkte anbieten, die nicht schon in einer ANDEREN
  // Zeile gewählt sind (sonst könnte man dasselbe Produkt doppelt wählen).
  function refreshProductMenus(items, candidates) {
    const usedIds = new Set(items.map((i) => i.product.id));
    items.forEach((item) => {
      const currentId = item.product.id;
      item.productMenu.innerHTML = '';
      candidates
        .filter((p) => p.id === currentId || !usedIds.has(p.id))
        .forEach((p) => {
          const opt = document.createElement('button');
          opt.type = 'button';
          opt.className = 'ds-bundle-item__product-option';
          if (p.id === currentId) opt.classList.add('is-selected');
          opt.dataset.productId = String(p.id);

          const img = document.createElement('img');
          img.src = p.featured_image ? p.featured_image + '&width=80' : '';
          img.alt = '';
          img.loading = 'lazy';

          const label = document.createElement('span');
          label.textContent = p.title;

          opt.appendChild(img);
          opt.appendChild(label);
          item.productMenu.appendChild(opt);
        });
    });
  }

  // Funktioniert für beide Zeilen-Varianten: Zeilen mit Produkt-Wechsel-
  // Dropdown (item.productTriggerName, "Eigenes Bundle") und einfache
  // Zeilen mit statischem Namen (item.nameEl, "Partnerlook").
  function applyProduct(item, product) {
    item.product = product;
    item.imgEl.src = product.featured_image ? product.featured_image + '&width=160' : '';
    item.imgEl.alt = product.title;
    if (item.linkEl) {
      item.linkEl.href = product.url || (product.handle ? '/products/' + product.handle : '#');
    }
    if (item.productTriggerName) item.productTriggerName.textContent = product.title;
    if (item.nameEl) item.nameEl.textContent = product.title;
    buildSizeOptions(item.sizeSelect, product);
    updateItemPrice(item, item.rate);
  }

  // Einfache Zeile ohne Produkt-Wechsel-Dropdown (Bild + Name + Grösse +
  // Preis) - für "Partnerlook", wo die zwei Produkte (Erwachsen + Kids)
  // fix sind und nicht getauscht werden können.
  function renderStaticItem(roleLabel) {
    const wrap = document.createElement('div');
    wrap.className = 'ds-bundle-item';

    const imgWrap = document.createElement('a');
    imgWrap.className = 'ds-bundle-item__image';
    imgWrap.target = '_blank';
    imgWrap.rel = 'noopener';
    imgWrap.setAttribute('aria-label', I18N.viewProduct);
    const imgEl = document.createElement('img');
    imgEl.loading = 'lazy';
    imgWrap.appendChild(imgEl);

    const info = document.createElement('div');
    info.className = 'ds-bundle-item__info';

    const nameRow = document.createElement('p');
    nameRow.className = 'ds-bundle-item__static-name';
    const name = document.createElement('span');
    nameRow.appendChild(name);

    const price = document.createElement('p');
    price.className = 'ds-bundle-item__price';

    info.appendChild(nameRow);
    info.appendChild(price);

    // Rechte Spalte: Rollen-Pille (Erwachsene/Kinder) ueber dem Groessen-
    // Select statt unter dem Namen -> die Zeile wird niedriger (Sean 29.10.)
    const side = document.createElement('div');
    side.className = 'ds-bundle-item__side';
    if (roleLabel) {
      const badge = document.createElement('span');
      badge.className = 'ds-bundle-item__role-badge ds-bundle-item__role-badge--' + roleLabel.toLowerCase();
      badge.textContent = roleLabel === 'kinder' ? I18N.partner.roleKids : I18N.partner.roleAdults;
      side.appendChild(badge);
    }

    const sizeSelect = document.createElement('select');
    sizeSelect.className = 'ds-bundle-item__size';
    sizeSelect.setAttribute('aria-label', I18N.selectSize);
    side.appendChild(sizeSelect);

    wrap.appendChild(imgWrap);
    wrap.appendChild(info);
    wrap.appendChild(side);

    return { el: wrap, imgEl, linkEl: imgWrap, nameEl: name, sizeSelect, priceEl: price, product: null, rate: 0 };
  }

  // "X" zum Entfernen einer Bundle-Zeile (Partnerlook-Kinderpaare UND
  // Eigenes Bundle). Sichtbarkeit steuert der jeweilige Tab.
  // Sichtbarkeit des X: nicht per hidden/display (wuerde das Layout der
  // Zeile verschieben), sondern per Klasse -> visibility. Der Platz bleibt
  // damit bei 3, 4, 5 ... Zeilen identisch reserviert.
  function setRemoveEnabled(item, enabled) {
    if (!item.removeBtn) return;
    item.removeBtn.classList.toggle('is-disabled', !enabled);
    item.removeBtn.setAttribute('aria-disabled', enabled ? 'false' : 'true');
    item.removeBtn.tabIndex = enabled ? 0 : -1;
  }

  function addRemoveButton(item, label) {
    const rm = document.createElement('button');
    rm.type = 'button';
    rm.className = 'ds-bundle-item__remove';
    rm.setAttribute('aria-label', label || I18N.custom.removeDefault);
    rm.innerHTML = '<i class="fa-solid fa-xmark" aria-hidden="true"></i>';
    item.el.appendChild(rm);
    item.removeBtn = rm;
    return rm;
  }

  function renderItem() {
    const wrap = document.createElement('div');
    wrap.className = 'ds-bundle-item';

    const imgWrap = document.createElement('a');
    imgWrap.className = 'ds-bundle-item__image';
    imgWrap.target = '_blank';
    imgWrap.rel = 'noopener';
    imgWrap.setAttribute('aria-label', I18N.viewProduct);
    const imgEl = document.createElement('img');
    imgEl.loading = 'lazy';
    imgWrap.appendChild(imgEl);

    const info = document.createElement('div');
    info.className = 'ds-bundle-item__info';

    const picker = document.createElement('div');
    picker.className = 'ds-bundle-item__product-picker';

    const trigger = document.createElement('button');
    trigger.type = 'button';
    trigger.className = 'ds-bundle-item__product-trigger';
    trigger.setAttribute('aria-haspopup', 'listbox');
    trigger.setAttribute('aria-expanded', 'false');

    const triggerName = document.createElement('span');
    triggerName.className = 'ds-bundle-item__product-trigger-name';
    trigger.appendChild(triggerName);

    const chevron = document.createElement('i');
    chevron.className = 'fa-solid fa-chevron-down';
    chevron.setAttribute('aria-hidden', 'true');
    trigger.appendChild(chevron);

    const menu = document.createElement('div');
    menu.className = 'ds-bundle-item__product-menu';
    menu.setAttribute('role', 'listbox');
    menu.hidden = true;

    picker.appendChild(trigger);
    picker.appendChild(menu);

    const price = document.createElement('p');
    price.className = 'ds-bundle-item__price';

    info.appendChild(picker);
    info.appendChild(price);

    const sizeSelect = document.createElement('select');
    sizeSelect.className = 'ds-bundle-item__size';
    sizeSelect.setAttribute('aria-label', I18N.selectSize);

    wrap.appendChild(imgWrap);
    wrap.appendChild(info);
    wrap.appendChild(sizeSelect);

    return {
      el: wrap,
      imgEl,
      linkEl: imgWrap,
      productTrigger: trigger,
      productTriggerName: triggerName,
      productMenu: menu,
      sizeSelect,
      priceEl: price,
      product: null,
      rate: 0,
    };
  }

  function sumItemsPrice(items) {
    let total = 0;
    items.forEach((item) => {
      const opt = item.sizeSelect.selectedOptions[0];
      if (opt) total += parseInt(opt.dataset.price, 10);
    });
    return total;
  }

  function itemUnitPrices(items) {
    const prices = [];
    items.forEach((item) => {
      const opt = item.sizeSelect.selectedOptions[0];
      if (opt) prices.push(parseInt(opt.dataset.price, 10));
    });
    return prices;
  }

  // Shopify zieht den Rabatt PRO Artikel ab und rundet dabei auf ganze Rappen
  // ab. Rechnet man stattdessen auf die Gesamtsumme, weicht die Anzeige um
  // ein paar Rappen von der Kasse ab (z.B. 71.83 statt 71.85 bei 5×16.90).
  function discountedTotal(unitPrices, rate) {
    return unitPrices.reduce((sum, p) => sum + p - Math.floor(p * rate), 0);
  }

  // Gesamtpreis "Eigenes Bundle": Satz haengt an der Zeilenanzahl
  // (bundleRate) — Zeilenpreise und Label ziehen mit.
  function updateTotal(root, items) {
    const rate = bundleRate(items.length);
    items.forEach((item) => {
      item.rate = rate;
      updateItemPrice(item, rate);
    });
    const total = sumItemsPrice(items);
    const discounted = discountedTotal(itemUnitPrices(items), rate);
    root.querySelector('[data-ds-bundle-total-now]').textContent = formatMoney(discounted);
    const was = root.querySelector('[data-ds-bundle-total-was]');
    was.textContent = formatMoney(total);
    was.hidden = rate <= 0;
    const label = root.querySelector('[data-ds-bundle-total-label]');
    if (label) label.textContent = fmt(I18N.custom.totalLabelTemplate, { percent: Math.round(rate * 100) });
    setPerPair(root.querySelector('[data-ds-bundle-per-pair]'), discounted, sumPairs(items));
    toggleShipping(root.querySelector('[data-ds-bundle-shipping]'), discounted);
  }

  // Fügt alle Bundle-Zeilen dem echten Shopify-Warenkorb hinzu UND informiert
  // Horizons eigene Warenkorb-Komponenten (Drawer, Icon-Zähler) korrekt
  // darüber – über dasselbe Event-System, das auch der normale "In den
  // Warenkorb"-Button nutzt. Ein simples `document.dispatchEvent(neues
  // CustomEvent(...))` (frühere Version) wird von Horizon nicht erkannt,
  // wodurch der Warenkorb serverseitig zwar korrekt befüllt wurde, der
  // Drawer beim Öffnen aber leer/veraltet aussah.
  async function addLinesToCart(root, cartItems, button, mode) {
    button.disabled = true;
    const originalText = button.innerHTML;
    button.innerHTML = I18N.cart.adding;

    // Bundle-Markierung für die Discount Function: nur wenn dieser Klick
    // überhaupt rabattberechtigt ist (Gesamtmenge >= 2). "Einzeln" (1 Stück)
    // bleibt unmarkiert und damit unrabattiert.
    // Das Suffix "-n<Menge>" hält fest, wie gross das Bundle beim Hinzufügen
    // war. Beim "Eigenen Bundle" (mix) streicht die Function den Rabatt
    // komplett, sobald die Gruppe im Warenkorb kleiner ist als versprochen.
    const totalQty = cartItems.reduce((sum, ci) => sum + ci.quantity, 0);
    if (totalQty >= 2) {
      const tag = makeBundleTag(mode || 'bundle') + '-n' + totalQty;
      cartItems = cartItems.map((ci) => ({
        ...ci,
        properties: { ...(ci.properties || {}), _ds_bundle: tag },
      }));
    }

    const deferred = CartLinesUpdateEvent.createPromise();
    document.dispatchEvent(
      new CartLinesUpdateEvent({
        action: 'add',
        context: 'product',
        lines: cartItems.map((ci) => ({ merchandiseId: ci.id, quantity: ci.quantity })),
        promise: deferred.promise,
      })
    );

    try {
      /* Ein Item pro /cart/add.js-Request — nicht als Bulk.
         Shopify's shop_events_listener verwirft product_added_to_cart, wenn
         eine Cart-Transform-Function mehrere Lines zu einer zusammenzieht
         (Request-Items != Response-Lines). Bekannter Shopify-Bug; Workaround
         laut Shopify: separate Adds. Jeder Call feuert dann ein Pixel-Event. */
      for (const item of cartItems) {
        const res = await fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ items: [item] }),
        });
        if (!res.ok) throw new Error('Cart add failed');
      }

      const cartRes = await fetch('/cart.js');
      const ajaxCart = await cartRes.json();

      deferred.resolve({
        cart: CartLinesUpdateEvent.createCartFromAjaxResponse(ajaxCart),
        detail: { items: ajaxCart.items, itemCount: ajaxCart.item_count, didError: false },
      });

      button.innerHTML = I18N.cart.added;
      setTimeout(() => {
        button.innerHTML = originalText;
        button.disabled = false;
      }, 2500);
    } catch (e) {
      deferred.resolve({ detail: { didError: true } });
      button.innerHTML = I18N.cart.error;
      button.disabled = false;
    }
  }

  // ---------------------------------------------------------------------
  // "Eigenes Bundle" (Mix): startet mit Empfehlungen, jede Zeile hat
  // Produkt-Wechsel-Dropdown, Groesse und "X" (entfernen, solange >= 2
  // Zeilen bleiben). "+ Weiteres Design hinzufuegen" oeffnet den Picker-
  // Drawer (Suche + Kuerzlich angesehen); Klick auf eine Karte haengt das
  // Produkt als neue Zeile an. Rabatt: 2 = 5 %, 4 = 10 %, ab 6 = 15 %.
  // ---------------------------------------------------------------------
  async function initCustomBundle(root) {
    const productId = root.dataset.productId;
    const currentHandle = root.dataset.productHandle;
    const loading = root.querySelector('[data-ds-bundle-loading]');
    const itemsWrap = root.querySelector('[data-ds-bundle-items]');
    const shippingEl = root.querySelector('[data-ds-bundle-shipping]');
    const totalEl = root.querySelector('[data-ds-bundle-total]');
    const addBtn = root.querySelector('[data-ds-bundle-add]');
    const addRowBtn = root.querySelector('[data-ds-bundle-add-row]');
    const emptyEl = root.querySelector('[data-ds-bundle-empty]');

    const items = [];
    let candidates = [];
    let picker = null;

    function usedIds() {
      return new Set(items.map((i) => i.product.id));
    }

    // Wenn "X" ueberall aktiv/inaktiv: bei genau MIX_MIN_ITEMS Zeilen darf
    // nichts mehr entfernt werden -> Buttons ausblenden.
    function refreshRemoveButtons() {
      const canRemove = items.length > MIX_MIN_ITEMS;
      items.forEach((item) => setRemoveEnabled(item, canRemove));
    }

    function afterChange() {
      refreshProductMenus(items, candidates);
      refreshRemoveButtons();
      updateTotal(root, items);
      if (picker) picker.refreshUsed();
    }

    function addRow(product) {
      // Duplikate sind im Bundle nicht vorgesehen: dasselbe Produkt hoechstens einmal.
      if (usedIds().has(product.id)) return null;
      const item = renderItem();
      item.rate = bundleRate(items.length + 1);
      itemsWrap.appendChild(item.el);
      applyProduct(item, product);
      if (!candidates.some((c) => c.id === product.id)) candidates.push(product);

      item.sizeSelect.addEventListener('change', () => {
        updateItemPrice(item, item.rate);
        updateTotal(root, items);
      });

      item.productTrigger.addEventListener('click', (e) => {
        e.stopPropagation();
        const isOpen = !item.productMenu.hidden;
        closeAllMenus(items);
        if (!isOpen) {
          item.productMenu.hidden = false;
          item.productTrigger.setAttribute('aria-expanded', 'true');
        }
      });

      item.productMenu.addEventListener('click', (e) => {
        e.stopPropagation();
        const optionBtn = e.target.closest('.ds-bundle-item__product-option');
        if (!optionBtn) return;
        const newProduct = candidates.find((p) => String(p.id) === optionBtn.dataset.productId);
        if (!newProduct) return;
        applyProduct(item, newProduct);
        closeAllMenus(items);
        afterChange();
      });

      addRemoveButton(item, I18N.custom.removeFromBundle).addEventListener('click', () => {
        if (items.length <= MIX_MIN_ITEMS) return;
        itemsWrap.removeChild(item.el);
        items.splice(items.indexOf(item), 1);
        afterChange();
      });

      items.push(item);
      return item;
    }

    // Produkt per Handle nachladen (.js liefert Varianten mit Preis +
    // Verfuegbarkeit im Markt) und als Zeile anhaengen.
    async function addByHandle(handle) {
      const existing = candidates.find((c) => c.handle === handle);
      const product = existing || (await fetch(ROOT + '/products/' + handle + '.js').then((r) => r.json()));
      if (!product || !product.variants || !product.variants.some((v) => v.available)) return false;
      const item = addRow(product);
      if (!item) return false;
      afterChange();
      item.el.scrollIntoView({ block: 'nearest', behavior: 'smooth' });
      return true;
    }

    // ---------------------------------------------------------------
    // Picker-Drawer: Suchfeld, Quick-Links (Kollektionen), darunter ohne
    // aktive Suche "Kuerzlich angesehen" + "Bestseller"; mit Suche/Quick-
    // Link eine Trefferliste. Alle Listen laden seitenweise nach (Infinite
    // Scroll via IntersectionObserver auf einer Sentinel-Zeile). Karten =
    // native Produktkarten von "Kuerzlich angesehen" (ds-recently-viewed.js),
    // Handles kommen aus ds-search.js (searchPage / collectionPage).
    // ---------------------------------------------------------------
    const QUICK_LINKS = [
      { label: I18N.picker.quickLinks.bestseller, handle: 'bestseller' },
      { label: I18N.picker.quickLinks.colorful, handle: 'bunte-socken' },
      { label: I18N.picker.quickLinks.solid, handle: 'einfarbige-socken' },
    ];
    const BEST_HANDLE = 'bestseller';

    function ensurePicker() {
      if (picker) return picker;
      const drawer = window.dsDrawer.create({
        title: I18N.picker.title,
        ariaLabel: I18N.picker.ariaLabel,
        className: 'ds-bpick',
      });
      drawer.body.innerHTML =
        '<div class="ds-bpick__search"><input type="search" placeholder="' + I18N.picker.searchPlaceholder + '" aria-label="' + I18N.picker.searchAria + '" autocomplete="off">' +
        '<svg width="17" height="17" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"><circle cx="11" cy="11" r="7"/><path d="M21 21l-4-4"/></svg></div>' +
        '<div class="ds-bpick__quick" role="group" aria-label="' + I18N.picker.categoriesAria + '">' +
        QUICK_LINKS.map((q) => '<button type="button" class="ds-bpick__chip" data-bpick-quick="' + q.handle + '">' + q.label + '</button>').join('') +
        '</div>' +
        '<p class="ds-bpick__hint">' + I18N.picker.hint + '</p>' +
        '<div class="ds-bpick__section" data-bpick-results hidden><h3 class="ds-bpick__heading" data-bpick-results-title>' + I18N.picker.resultsHeading + '</h3><div class="ds-bpick__grid" data-bpick-results-grid></div><p class="ds-bpick__empty" data-bpick-results-empty hidden></p></div>' +
        '<div class="ds-bpick__section" data-bpick-recent><h3 class="ds-bpick__heading">' + I18N.picker.recentHeading + '</h3><div class="ds-bpick__grid" data-bpick-recent-grid></div><p class="ds-bpick__empty" data-bpick-recent-empty hidden>' + I18N.picker.recentEmpty + '</p></div>' +
        '<div class="ds-bpick__section" data-bpick-best><h3 class="ds-bpick__heading">' + I18N.picker.bestsellerHeading + '</h3><div class="ds-bpick__grid" data-bpick-best-grid></div><p class="ds-bpick__empty" data-bpick-best-empty hidden></p></div>' +
        '<div class="ds-bpick__sentinel" data-bpick-sentinel><span class="ds-bpick__loading" hidden>' + I18N.picker.loadingMore + '</span></div>';

      const input = drawer.body.querySelector('input');
      const chips = [...drawer.body.querySelectorAll('[data-bpick-quick]')];
      const resultsSec = drawer.body.querySelector('[data-bpick-results]');
      const resultsTitle = drawer.body.querySelector('[data-bpick-results-title]');
      const resultsGrid = drawer.body.querySelector('[data-bpick-results-grid]');
      const resultsEmpty = drawer.body.querySelector('[data-bpick-results-empty]');
      const recentSec = drawer.body.querySelector('[data-bpick-recent]');
      const recentGrid = drawer.body.querySelector('[data-bpick-recent-grid]');
      const recentEmpty = drawer.body.querySelector('[data-bpick-recent-empty]');
      const bestSec = drawer.body.querySelector('[data-bpick-best]');
      const bestGrid = drawer.body.querySelector('[data-bpick-best-grid]');
      const bestEmpty = drawer.body.querySelector('[data-bpick-best-empty]');
      const sentinel = drawer.body.querySelector('[data-bpick-sentinel]');
      const sentinelLabel = sentinel.querySelector('.ds-bpick__loading');

      // Karte "auswaehlbar" machen: Klick = zum Bundle, keine Navigation.
      // Bereits enthaltene Produkte werden markiert und sind nicht klickbar.
      function wrapCard(cardEl, handle) {
        const cell = document.createElement('div');
        cell.className = 'ds-bpick__cell';
        cell.dataset.handle = handle;
        cell.appendChild(cardEl);
        const mark = document.createElement('span');
        mark.className = 'ds-bpick__added';
        mark.innerHTML = '<i class="fa-solid fa-check" aria-hidden="true"></i> ' + I18N.picker.addedMark;
        cell.appendChild(mark);
        cell.addEventListener('click', async (e) => {
          e.preventDefault();
          e.stopPropagation();
          if (cell.classList.contains('is-used') || cell.classList.contains('is-busy')) return;
          cell.classList.add('is-busy');
          const ok = await addByHandle(handle);
          cell.classList.remove('is-busy');
          if (ok) drawer.close();
        }, true);
        return cell;
      }

      function refreshUsed() {
        const handles = new Set(items.map((i) => i.product.handle));
        drawer.body.querySelectorAll('.ds-bpick__cell').forEach((cell) => {
          cell.classList.toggle('is-used', handles.has(cell.dataset.handle) || cell.dataset.handle === currentHandle);
        });
      }

      // Karten fuer eine Handle-Liste holen und ANHAENGEN (Nachladen ersetzt
      // nichts). Doppelte Handles innerhalb einer Liste werden uebersprungen.
      async function appendCards(list, handles) {
        const rv = window.dsRecentlyViewed;
        const fresh = handles.filter((h) => h && h !== currentHandle && !list.seen.has(h));
        fresh.forEach((h) => list.seen.add(h));
        if (!rv || !fresh.length) return 0;
        const cards = await Promise.all(fresh.map((h) => rv.fetchCard(h).then((c) => (c ? { h, c } : null))));
        const valid = cards.filter(Boolean);
        valid.forEach(({ h, c }) => list.grid.appendChild(wrapCard(c, h)));
        refreshUsed();
        return valid.length;
      }

      // ---- Seitenweise Listen (Suche / Kollektion / Bestseller) --------
      // Ein Listen-Objekt pro Raster: { grid, emptyEl, seen, page, next,
      // loading, source: (page) => Promise<{handles,next}>, token }.
      // `token` schuetzt vor veralteten Antworten (neue Suche gestartet).
      function makeList(grid, emptyEl) {
        return { grid, emptyEl, seen: new Set(), page: 0, next: false, loading: false, source: null, token: 0, emptyText: '' };
      }
      function resetList(list, source, emptyText) {
        list.token += 1;
        list.grid.innerHTML = '';
        list.seen = new Set();
        list.page = 0;
        list.next = true;
        list.loading = false;
        list.source = source;
        list.emptyText = emptyText || '';
        list.emptyEl.hidden = true;
      }
      async function loadMore(list) {
        if (!list.source || list.loading || !list.next) return;
        list.loading = true;
        const token = list.token;
        const nextPage = list.page + 1;
        sentinelLabel.hidden = false;
        try {
          const res = await list.source(nextPage);
          if (token !== list.token) return; /* inzwischen zurueckgesetzt */
          list.page = nextPage;
          list.next = !!res.next;
          const added = await appendCards(list, res.handles);
          if (token !== list.token) return;
          if (!list.grid.children.length && !list.next) {
            list.emptyEl.textContent = list.emptyText;
            list.emptyEl.hidden = false;
          }
          // Seite lieferte nur schon bekannte/aktuelle Handles -> direkt weiter
          if (!added && list.next && res.handles.length) {
            list.loading = false;
            return loadMore(list);
          }
        } catch (e) {
          list.next = false;
        } finally {
          if (token === list.token) list.loading = false;
          sentinelLabel.hidden = true;
        }
      }

      const results = makeList(resultsGrid, resultsEmpty);
      const best = makeList(bestGrid, bestEmpty);
      let mode = 'default'; // 'default' | 'search' | 'collection'
      let activeList = best;

      function setMode(next) {
        mode = next;
        const showDefault = mode === 'default';
        resultsSec.hidden = showDefault;
        recentSec.hidden = !showDefault;
        bestSec.hidden = !showDefault;
        activeList = showDefault ? best : results;
      }

      function setActiveChip(handle) {
        chips.forEach((c) => c.classList.toggle('is-active', c.dataset.bpickQuick === handle));
      }

      // Nachladen, sobald die Sentinel-Zeile ins Bild scrollt (Root = Body
      // des Drawers, der ist das Scroll-Element).
      const io = new IntersectionObserver((entries) => {
        if (entries.some((en) => en.isIntersecting)) loadMore(activeList);
      }, { root: drawer.body, rootMargin: '200px 0px' });
      io.observe(sentinel);
      // Fallback: Scroll-Position pruefen (falls der Observer in einem
      // Browser nicht ausloest). loadMore ist gegen Doppelaufrufe geschuetzt.
      let scrollTick = false;
      drawer.body.addEventListener('scroll', () => {
        if (scrollTick) return;
        scrollTick = true;
        requestAnimationFrame(() => {
          scrollTick = false;
          const b = drawer.body;
          if (b.scrollTop + b.clientHeight >= b.scrollHeight - 300) loadMore(activeList);
        });
      }, { passive: true });

      let recentLoaded = false;
      async function loadRecent() {
        // Einmal laden; war der Verlauf beim ersten Oeffnen leer, beim
        // naechsten Oeffnen erneut versuchen.
        if (recentLoaded && recentGrid.children.length) return;
        const rv = window.dsRecentlyViewed;
        const history = rv ? rv.readHistory().filter((h) => h !== currentHandle).slice(0, 6) : [];
        if (!history.length) {
          recentEmpty.hidden = false;
          return;
        }
        recentLoaded = true;
        const rec = makeList(recentGrid, recentEmpty);
        await appendCards(rec, history);
        recentEmpty.hidden = recentGrid.children.length > 0;
      }

      function startCollection(handle, title) {
        setActiveChip(handle);
        setMode('collection');
        resultsTitle.textContent = title;
        resetList(results, (page) => window.dsSearch.collectionPage(handle, page), I18N.picker.noProductsInCollection);
        loadMore(results);
      }

      function backToDefault() {
        setActiveChip(null);
        setMode('default');
        resetList(results, null, '');
        if (!best.source) {
          resetList(best, (page) => window.dsSearch.collectionPage(BEST_HANDLE, page), I18N.picker.noBestsellers);
          loadMore(best);
        }
      }

      window.dsSearch.bindInput(input, {
        onClear: backToDefault,
        onQuery: (q) => {
          setActiveChip(null);
          setMode('search');
          resultsTitle.textContent = I18N.picker.resultsHeading;
          resetList(results, (page) => window.dsSearch.searchPage(q, page), fmt(I18N.picker.noResultsFor, { query: q }));
          loadMore(results);
        },
      });

      chips.forEach((chip) => {
        chip.addEventListener('click', () => {
          const handle = chip.dataset.bpickQuick;
          input.value = '';
          if (chip.classList.contains('is-active')) {
            backToDefault();
            return;
          }
          startCollection(handle, chip.textContent);
        });
      });

      picker = {
        open: () => {
          drawer.open();
          if (mode === 'default') backToDefault();
          loadRecent();
          refreshUsed();
          setTimeout(() => input.focus({ preventScroll: true }), 350);
        },
        refreshUsed,
      };
      return picker;
    }

    try {
      const res = await fetch(
        ROOT + '/recommendations/products.json?product_id=' + productId + '&limit=' + CANDIDATE_POOL_LIMIT + '&intent=related'
      );
      const data = await res.json();
      candidates = (data.products || []).filter(
        (p) => p.variants.filter((v) => v.available).length >= MIN_AVAILABLE_VARIANTS
      );
      const chosen = candidates.slice(0, INITIAL_ITEMS);

      loading.hidden = true;

      if (chosen.length < MIX_MIN_ITEMS) {
        emptyEl.hidden = false;
        return;
      }

      chosen.forEach((product) => addRow(product));
      document.addEventListener('click', () => closeAllMenus(items));

      itemsWrap.hidden = false;
      /* shippingEl steuert updateTotal ueber die Gratisversand-Schwelle */
      totalEl.hidden = false;
      addBtn.hidden = false;
      if (addRowBtn) {
        addRowBtn.hidden = false;
        addRowBtn.addEventListener('click', () => ensurePicker().open());
      }
      afterChange();

      addBtn.addEventListener('click', () => {
        const cartItems = items.map((item) => ({ id: parseInt(item.sizeSelect.value, 10), quantity: 1 }));
        addLinesToCart(root, cartItems, addBtn, 'mix');
      });
    } catch (e) {
      loading.hidden = true;
      emptyEl.hidden = false;
    }
  }

  // ---------------------------------------------------------------------
  // "Gleiches Design": dasselbe Produkt in grösserer Menge, mit
  // Mengenrabatt-Stufen (Einzeln / Zweierpack / Fünferpack). Nutzt die
  // Grösse, die aktuell im Hauptformular der Produktseite gewählt ist.
  // ---------------------------------------------------------------------
  function getSelectedVariantId() {
    const input = document.querySelector('form[action*="/cart/add"] input[name="id"]');
    return input ? parseInt(input.value, 10) : null;
  }

  async function initSameDesign(root) {
    const panel = root.querySelector('[data-tab="same"]');
    if (!panel) return;
    const handle = root.dataset.productHandle;
    const tiersWrap = panel.querySelector('[data-ds-tiers]');
    const totalNow = panel.querySelector('[data-ds-same-total-now]');
    const totalWas = panel.querySelector('[data-ds-same-total-was]');
    const perPairEl = panel.querySelector('[data-ds-same-per-pair]');
    const addBtn = panel.querySelector('[data-ds-same-add]');

    let productData = null;
    let selectedTierIndex = 0;

    function currentVariant() {
      const variantId = getSelectedVariantId();
      return (
        productData.variants.find((v) => v.id === variantId) ||
        productData.variants.find((v) => v.available) ||
        productData.variants[0]
      );
    }

    function render() {
      if (!productData) return;
      const variant = currentVariant();
      const unitPrice = variant.price; // .js-Endpoint liefert Preis bereits in Rappen

      tiersWrap.innerHTML = '';
      SAME_DESIGN_TIERS.forEach((tier, i) => {
        const total = unitPrice * tier.qty;
        const discounted = discountedTotal(new Array(tier.qty).fill(unitPrice), tier.discount);

        const row = document.createElement('label');
        row.className = 'ds-tier' + (i === selectedTierIndex ? ' is-selected' : '');

        const radio = document.createElement('input');
        radio.type = 'radio';
        radio.className = 'ds-tier__radio';
        radio.name = 'ds-same-tier-' + root.dataset.productId;
        radio.checked = i === selectedTierIndex;
        radio.addEventListener('change', () => {
          selectedTierIndex = i;
          render();
        });

        const left = document.createElement('span');
        left.className = 'ds-tier__left';
        left.appendChild(radio);

        const textWrap = document.createElement('span');
        textWrap.className = 'ds-tier__text';

        if (tier.discount > 0 || tier.bestDeal) {
          const badges = document.createElement('span');
          badges.className = 'ds-tier__badges';
          if (tier.discount > 0) {
            const b = document.createElement('span');
            b.className = 'ds-tier__badge';
            b.textContent = fmt(I18N.sameDesign.discountBadge, { percent: Math.round(tier.discount * 100) });
            badges.appendChild(b);
          }
          if (tier.bestDeal) {
            const b2 = document.createElement('span');
            b2.className = 'ds-tier__badge ds-tier__badge--best';
            b2.textContent = I18N.sameDesign.bestDeal;
            badges.appendChild(b2);
          }
          textWrap.appendChild(badges);
        }

        const label = document.createElement('span');
        label.className = 'ds-tier__label';
        const tierPairs = tier.qty * pairsPerUnit(productData);
        const pairsTemplate = tierPairs === 1 ? I18N.sameDesign.pairsSuffixOne : I18N.sameDesign.pairsSuffix;
        label.textContent = tier.label + ' ' + fmt(pairsTemplate, { count: tierPairs });
        textWrap.appendChild(label);

        left.appendChild(textWrap);

        const price = document.createElement('span');
        price.className = 'ds-tier__price';
        const now = document.createElement('strong');
        now.textContent = formatMoney(discounted);
        price.appendChild(now);
        if (tier.discount > 0) {
          const was = document.createElement('s');
          was.textContent = formatMoney(total);
          price.appendChild(was);
        }

        row.appendChild(left);
        row.appendChild(price);
        tiersWrap.appendChild(row);
      });

      const tier = SAME_DESIGN_TIERS[selectedTierIndex];
      const total = unitPrice * tier.qty;
      const discounted = discountedTotal(new Array(tier.qty).fill(unitPrice), tier.discount);
      const totalPairs = tier.qty * pairsPerUnit(productData);
      totalNow.textContent = formatMoney(discounted);
      setPerPair(perPairEl, discounted, totalPairs);
      if (totalWas) {
        if (tier.discount > 0) {
          totalWas.textContent = formatMoney(total);
          totalWas.hidden = false;
        } else {
          totalWas.hidden = true;
        }
      }
    }

    root.querySelectorAll('[data-tab-btn="same"]').forEach((btn) => btn.addEventListener('click', render));

    addBtn.addEventListener('click', () => {
      if (!productData) return;
      const variant = currentVariant();
      const tier = SAME_DESIGN_TIERS[selectedTierIndex];
      addLinesToCart(root, [{ id: variant.id, quantity: tier.qty }], addBtn, 'same');
    });

    try {
      // Bewusst die AJAX-API (.js) statt /products/{handle}.json: Letztere
      // liefert pro Variante KEIN `available`-Feld, wodurch z.B. die
      // Ausverkauft-Erkennung stillschweigend fehlschlagen würde.
      const res = await fetch(ROOT + '/products/' + handle + '.js');
      productData = await res.json();
      render();
    } catch (e) {
      panel.innerHTML = '<p class="ds-bundle__empty">' + I18N.sameDesign.unavailable + '</p>';
    }
  }

  // ---------------------------------------------------------------------
  // "Partnerlook": das aktuelle Produkt zusammen mit dem passenden
  // Gegenstück desselben Motivs - richtungsabhängig (siehe
  // findPartnerProduct). Kein Match -> kein Ersatzprodukt, sondern ein
  // Kollektions-Link (siehe initPartnerlook).
  // ---------------------------------------------------------------------
  function normalizeCollectionProduct(p) {
    return {
      id: p.id,
      title: p.title,
      handle: p.handle,
      featured_image: p.images && p.images[0] ? p.images[0].src : p.featured_image || null,
      variants: (p.variants || []).map((v) => ({
        id: v.id,
        title: v.title,
        public_title: v.title,
        available: v.available,
        price: Math.round(parseFloat(v.price) * 100),
        compare_at_price: v.compare_at_price ? Math.round(parseFloat(v.compare_at_price) * 100) : 0,
      })),
    };
  }

  function isUsableKidsProduct(p) {
    return p && p.title && !p.title.toLowerCase().startsWith('pos ') && (p.variants || []).some((v) => v.available);
  }

  // Kids-Produkte heissen bei DillySocks durchgängig "Lil " + derselbe Name
  // wie das Erwachsenen-Produkt (z.B. "Panda Pal" -> "Lil Panda Pal",
  // "Busy Bees" -> "Lil Busy Bees"). Das ist ein VIEL zuverlässigeres
  // Match-Signal als das "keywords"-Metafeld, das teils Deutsch, teils
  // Englisch befüllt ist und daher am englischen Kids-Titel vorbeischiessen
  // kann (z.B. "Biene" matcht nicht in "Lil Busy Bees").
  function stripLilPrefix(title) {
    return title.toLowerCase().replace(/^lil\s+/, '').trim();
  }

  // Sucht das Partnerlook-Gegenstück zum aktuellen Produkt. Läuft in BEIDE
  // Richtungen:
  // - Erwachsenen-Produkt -> sucht in der Kids-Kollektion nach "Lil " +
  //   demselben Namen.
  // - Kids-Produkt -> sucht in der allgemeinen Erwachsenen-Kollektion nach
  //   dem Namen OHNE "Lil "-Präfix.
  // Kein Treffer -> null (kein Fallback-Ersatzprodukt mehr, siehe
  // initPartnerlook).
  async function findPartnerProduct(currentTitle, keyword, isCurrentKids) {
    const targetCollection = isCurrentKids ? ADULT_COLLECTION_HANDLE : KIDS_COLLECTION_HANDLE;
    const res = await fetch(ROOT + '/collections/' + targetCollection + '/products.json?limit=250');
    const data = await res.json();
    const candidates = (data.products || []).filter(isUsableKidsProduct);

    const targetName = isCurrentKids ? stripLilPrefix(currentTitle) : currentTitle.toLowerCase().trim();
    const nameMatch = candidates.find((p) => {
      const candidateName = isCurrentKids ? p.title.toLowerCase().trim() : stripLilPrefix(p.title);
      return candidateName === targetName;
    });
    if (nameMatch) return normalizeCollectionProduct(nameMatch);

    if (keyword) {
      const keywordMatch = candidates.find((p) => p.title.toLowerCase().includes(keyword.toLowerCase()));
      if (keywordMatch) return normalizeCollectionProduct(keywordMatch);
    }

    return null;
  }

  async function initPartnerlook(root) {
    const panel = root.querySelector('[data-tab="partner"]');
    if (!panel) return;
    const handle = root.dataset.productHandle;
    const keyword = root.dataset.designKeyword;
    const isCurrentKids = (root.dataset.productType || '').toLowerCase().includes('kind');

    const loading = panel.querySelector('[data-ds-partner-loading]');
    const itemsWrap = panel.querySelector('[data-ds-partner-items]');
    const shippingEl = panel.querySelector('[data-ds-partner-shipping]');
    const totalEl = panel.querySelector('[data-ds-partner-total]');
    const addBtn = panel.querySelector('[data-ds-partner-add]');

    // Kein Partnerlook -> Tab komplett ausblenden (nur 2 Auswahlmoeglichkeiten).
    // Falls der Tab gerade aktiv war, auf "Eigenes Bundle" wechseln.
    function hidePartnerTab() {
      const tabBtn = root.querySelector('[data-tab-btn="partner"]');
      if (!tabBtn) return;
      const wasActive = tabBtn.classList.contains('ds-bundle__tab--active');
      tabBtn.hidden = true;
      if (wasActive) {
        const customBtn = root.querySelector('[data-tab-btn="custom"]');
        if (customBtn) customBtn.click();
      }
    }

    try {
      // AJAX-API (.js) statt /products/{handle}.json: liefert `available`
      // pro Variante direkt mit und braucht keine Preis-Umrechnung -
      // dasselbe Format wie die Empfehlungs-API, keine Normalisierung nötig.
      const currentProduct = await fetch(ROOT + '/products/' + handle + '.js').then((r) => r.json());
      const partnerProduct = await findPartnerProduct(currentProduct.title, keyword, isCurrentKids);

      loading.hidden = true;

      if (!partnerProduct) {
        hidePartnerTab();
        return;
      }

      // Immer in derselben Reihenfolge anzeigen: Erwachsene zuerst, Kids
      // danach - unabhängig davon, ob das AKTUELLE Produkt (auf dessen
      // Seite das Widget liegt) selbst das Kids- oder Erwachsenen-Produkt
      // ist.
      const products = isCurrentKids
        ? [
            { product: partnerProduct, role: 'erwachsene' },
            { product: currentProduct, role: 'kinder' },
          ]
        : [
            { product: currentProduct, role: 'erwachsene' },
            { product: partnerProduct, role: 'kinder' },
          ];
      const adultInfo = products[0];
      const kidInfo = products[1];

      // Erwachsenen- UND Kinder-Zeilen sind vermehrbar (je 1..6, gleiches
      // Design — z.B. Mama, Papa und mehrere Kinder). Der Rabattsatz haengt
      // an der Gesamtzahl der Paare (bundleRate, gleiche Kurve wie die
      // anderen Tabs).
      const adultsWrap = document.createElement('div');
      adultsWrap.className = 'ds-bundle__ptnr-kids';
      itemsWrap.appendChild(adultsWrap);

      const addAdultBtn = document.createElement('button');
      addAdultBtn.type = 'button';
      addAdultBtn.className = 'ds-bundle__add-row';
      addAdultBtn.innerHTML = '<i class="fa-solid fa-plus" aria-hidden="true"></i> ' + I18N.partner.addAnotherAdult;
      itemsWrap.appendChild(addAdultBtn);

      const divider = document.createElement('div');
      divider.className = 'ds-bundle__partner-divider';
      divider.innerHTML = '<i class="fa-solid fa-link" aria-hidden="true"></i> ' + I18N.partner.divider;
      itemsWrap.appendChild(divider);

      const kidsWrap = document.createElement('div');
      kidsWrap.className = 'ds-bundle__ptnr-kids';
      itemsWrap.appendChild(kidsWrap);

      const addKidBtn = document.createElement('button');
      addKidBtn.type = 'button';
      addKidBtn.className = 'ds-bundle__add-row';
      addKidBtn.innerHTML = '<i class="fa-solid fa-plus" aria-hidden="true"></i> ' + I18N.partner.addAnotherKid;
      itemsWrap.appendChild(addKidBtn);

      const adultRows = [];
      const kidRows = [];
      const MAX_ROWS_PER_ROLE = 6;

      function allItems() {
        return adultRows.concat(kidRows);
      }
      function currentRate() {
        return bundleRate(allItems().length);
      }

      function refreshRows() {
        adultRows.forEach((r) => setRemoveEnabled(r, adultRows.length > 1));
        kidRows.forEach((r) => setRemoveEnabled(r, kidRows.length > 1));
        addAdultBtn.hidden = adultRows.length >= MAX_ROWS_PER_ROLE;
        addKidBtn.hidden = kidRows.length >= MAX_ROWS_PER_ROLE;
        updatePartnerTotal();
      }

      function addRoleRow(info, wrap, rows) {
        if (rows.length >= MAX_ROWS_PER_ROLE) return;
        const item = renderStaticItem(info.role);
        item.rate = currentRate();
        const rm = addRemoveButton(item, I18N.partner.removePair);

        wrap.appendChild(item.el);
        applyProduct(item, info.product);
        if (info.role === 'kinder') {
          // Standardgrösse "2-3J", falls verfügbar
          const def = [...item.sizeSelect.options].find((o) => /2\s*[–-]\s*3/.test(o.textContent));
          if (def) item.sizeSelect.value = def.value;
        }
        item.sizeSelect.addEventListener('change', () => {
          updateItemPrice(item, currentRate());
          updatePartnerTotal();
        });
        rm.addEventListener('click', () => {
          if (rows.length <= 1) return;
          wrap.removeChild(item.el);
          rows.splice(rows.indexOf(item), 1);
          refreshRows();
        });
        rows.push(item);
        refreshRows();
      }

      addAdultBtn.addEventListener('click', () => addRoleRow(adultInfo, adultsWrap, adultRows));
      addKidBtn.addEventListener('click', () => addRoleRow(kidInfo, kidsWrap, kidRows));
      addRoleRow(adultInfo, adultsWrap, adultRows);
      addRoleRow(kidInfo, kidsWrap, kidRows);

      function updatePartnerTotal() {
        const items = allItems();
        const rate = currentRate();
        items.forEach((item) => {
          item.rate = rate;
          updateItemPrice(item, rate);
        });
        const total = sumItemsPrice(items);
        const discounted = discountedTotal(itemUnitPrices(items), rate);
        totalEl.querySelector('[data-ds-partner-total-now]').textContent = formatMoney(discounted);
        totalEl.querySelector('[data-ds-partner-total-was]').textContent = formatMoney(total);
        const label = totalEl.querySelector('[data-ds-partner-total-label]');
        if (label) {
          label.textContent =
            rate > 0 ? fmt(I18N.partner.totalLabelTemplate, { percent: Math.round(rate * 100) }) : I18N.partner.totalLabelZero;
        }
        setPerPair(totalEl.querySelector('[data-ds-partner-per-pair]'), discounted, sumPairs(items));
        toggleShipping(shippingEl, discounted);
      }

      itemsWrap.hidden = false;
      /* shippingEl steuert updatePartnerTotal ueber die Gratisversand-Schwelle */
      totalEl.hidden = false;
      addBtn.hidden = false;
      updatePartnerTotal();

      // Familiensocken mit gefundenem Partnerlook: "Partnerlook" ist der
      // Default-Tab (Sean 28.10.2026) — ausser der User hat schon selbst
      // einen Tab gewaehlt.
      if (!root.dataset.dsTabTouched) {
        const partnerBtn = root.querySelector('[data-tab-btn="partner"]');
        if (partnerBtn && !partnerBtn.hidden) partnerBtn.click();
      }

      addBtn.addEventListener('click', () => {
        const cartItems = allItems().map((item) => ({ id: parseInt(item.sizeSelect.value, 10), quantity: 1 }));
        addLinesToCart(root, cartItems, addBtn, 'partner');
      });
    } catch (e) {
      loading.hidden = true;
      hidePartnerTab();
    }
  }

  /* Info-i der Rabattstaffel: Klick/Tap toggelt den Tooltip (zusaetzlich
     zu :hover/:focus im CSS — mancher Mobile-Browser haelt den Fokus
     nicht). Klick daneben schliesst. */
  function initTiersInfo() {
    document.addEventListener('click', (e) => {
      const btn = e.target.closest('.ds-bundle__tiers-info');
      document.querySelectorAll('.ds-bundle__tiers-info.is-open').forEach((b) => {
        if (b !== btn) b.classList.remove('is-open');
      });
      if (btn) btn.classList.toggle('is-open');
    });
  }

  function init() {
    initTiersInfo();
    document.querySelectorAll('[data-ds-bundle]').forEach((root) => {
      initTabs(root);
      initCustomBundle(root);
      initSameDesign(root);
      initPartnerlook(root);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
